import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useNavigate } from 'react-router-dom';
import './PuzzlePage.css';
// import FeelModal from './components/FeelModal';
import { useAudio } from './AudioContext';
import bg4 from './images/bg4.webp';
import parentsVideo from './images/parents.mp4';
import friendsVideo from './images/friends.mp4';

const sweet = withReactContent(Swal);

// Using local video files instead of backend
const videos = { parents: parentsVideo, friends: friendsVideo };

export default function SurprisePage() {
  const [loading, setLoading] = useState(false); // No need to load from backend
  const [current, setCurrent] = useState(null); // 'parents' or 'friends'
  // const [showCamera, setShowCamera] = useState(false);
  // const [sending, setSending] = useState(false);
  // const [photo, setPhoto] = useState(null);
  // const [feelModalOpen, setFeelModalOpen] = useState(false);
  // const [feelInput, setFeelInput] = useState('');
  // const [afterFeel, setAfterFeel] = useState(null); // function to run after input
  const videoRef = useRef(null);
  const navigate = useNavigate();
  const { stopAll } = useAudio();

  // Stop all audio when entering SurprisePage
  useEffect(() => {
    stopAll();
  }, [stopAll]);

  // No need to fetch from backend - using local video files
  useEffect(() => {
    showIntro();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (videoRef.current && current) {
      const videoSrc = videos[current];
      if (videoSrc) {
        videoRef.current.src = videoSrc;
        videoRef.current.load();
        videoRef.current.play().catch(()=>{});
      }
    }
  }, [current, videos]);

  const showIntro = async () => {
    await sweet.fire({
      title: 'sayang harus liat🫶🏻',
      html: ` sekarang, revi ado surprise. hope you like it, love you!`,
      confirmButtonText: 'Love you more ✨',
      background: '#fdf5ff',
      color: '#7b64e8',
      confirmButtonColor: '#a96df0',
      allowOutsideClick: false,
      showClass: { popup: 'swal-pop-in' },
      hideClass: { popup: 'swal-pop-out' }
    });
    // Use local video files - always start with parents if available
    if (videos.parents) {
      setCurrent('parents');
    } else if (videos.friends) {
      setCurrent('friends');
    }
  };

  const handleEnded = async () => {
    if (current === 'parents' && videos.friends) {
      const result = await sweet.fire({
        title: 'Next video?',
        html: 'sayang nak lanjut ke video ke-2 atau ulang video ini?',
        showCancelButton: true,
        confirmButtonText: 'Next Video',
        cancelButtonText: 'Not yet',
        allowOutsideClick: false,
        background: '#fef8ff',
        color: '#7b64e8',
        confirmButtonColor: '#a96df0',
        cancelButtonColor: '#d0c4ff',
        showClass: { popup: 'swal-pop-in' },
        hideClass: { popup: 'swal-pop-out' }
      });
      if (result.isConfirmed) {
        setCurrent('friends');
      } else {
        // stay on parents and restart from beginning
        if (videoRef.current) {
          videoRef.current.currentTime = 0;
          videoRef.current.play().catch(()=>{});
        }
      }
    } else if (current === 'friends') {
      const result = await sweet.fire({
        title: 'Done or Repeat?🤔',
        showCancelButton: true,
        confirmButtonText: 'Done',
        cancelButtonText: 'Repeat',
        allowOutsideClick: false,
        background: '#fdf5ff',
        color: '#7b64e8',
        confirmButtonColor: '#a96df0',
        cancelButtonColor: '#d0c4ff',
        showClass: { popup: 'swal-pop-in' },
        hideClass: { popup: 'swal-pop-out' }
      });
      if (result.isConfirmed) {
        // Redirect to balloon page
        navigate('/balloon');
      } else {
        // repeat video 2
        if (videoRef.current) {
          videoRef.current.currentTime = 0;
          videoRef.current.play().catch(()=>{});
        }
      }
    }
  };

  return (
    <div className="surprise-wrapper" style={{ backgroundImage: `url(${bg4})` }}>
      <div className="surprise-card">
        <div className="surprise-title">Special Surprise 🎁</div>
        {loading && <div className="surprise-loading">Loading video...</div>}
        {!loading && !videos.parents && !videos.friends && (
          <div className="surprise-empty">Video tidak ditemukan.</div>
        )}
        {!loading && (videos.parents || videos.friends) && (
          <video
            ref={videoRef}
            className="surprise-video"
            controls
            onEnded={handleEnded}
          />
        )}
      </div>
      {/* Commented out camera and feel modal functionality */}
      {/* {showCamera && (
        <CameraModal
          onClose={() => { setShowCamera(false); setPhoto(null); }}
          photo={photo}
          setPhoto={setPhoto}
          sending={sending}
          onSend={async (dataUrl) => {
            try {
              setSending(true);
              const feeling = await new Promise(resolve => {
                setFeelModalOpen(true);
                setFeelInput('');
                setAfterFeel(()=>v=>resolve(v||''));
              });
              const res = await fetch('https://api.laviopaperie.com/upload-photo', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ image: dataUrl, feeling }),
              });
              if (!res.ok) throw new Error('Failed uploading to server');
              setSending(false);
              setShowCamera(false);
              setPhoto(null);
              sweet.fire({
                title: 'maacih sayang🫶🏻',
                html: 'Let\'s play!',
                timer: 1400,
                showConfirmButton: false,
                background: '#fef8ff',
                color: '#7b64e8',
                toast: true,
                position: 'top',
                showClass: { popup: 'swal-pop-in' },
                hideClass: { popup: 'swal-pop-out' }
              });
              navigate('/balloon');
            } catch (e) {
              alert('Gagal upload foto: ' + e.message);
              setSending(false);
            }
          }}
        />
      )}
      <FeelModal open={feelModalOpen} value={feelInput} onChange={setFeelInput}
        onCancel={()=>{setFeelModalOpen(false);afterFeel&&afterFeel('')}}
        onSend={()=>{setFeelModalOpen(false);afterFeel&&afterFeel(feelInput)}} /> */}
    </div>
  );
}

// Commented out CameraModal component
/* function CameraModal({ onClose, photo, setPhoto, onSend, sending }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const isSecure = window.isSecureContext || ['localhost','127.0.0.1'].includes(window.location.hostname);

  useEffect(() => {
    if (!photo && isSecure) {
      startCamera();
    } else if (!isSecure) {
      setError('Kamera membutuhkan https atau http://localhost');
    }
    return () => stopStream();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [photo, isSecure]);

  const stopStream = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(t => t.stop());
      streamRef.current = null;
    }
  };

  const startCamera = async () => {
    try {
      setLoading(true);
      const media = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' }, audio: false });
      streamRef.current = media;
      if (videoRef.current) {
        videoRef.current.srcObject = media;
        videoRef.current.muted = true;
        videoRef.current.setAttribute('playsinline', 'true');
        videoRef.current.style.transform = 'scaleX(-1)';
        await videoRef.current.play().catch(()=>{});
      }
      setLoading(false);
      setError(null);
    } catch (e) {
      setError('Tidak bisa akses kamera: ' + e.message);
      setLoading(false);
    }
  };

  const takePhoto = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !canvas) return;
    const w = video.videoWidth || 640;
    const h = video.videoHeight || 480;
    canvas.width = w; canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.save();
    ctx.translate(w, 0); ctx.scale(-1,1);
    ctx.drawImage(video, 0, 0, w, h);
    ctx.restore();
    ctx.fillStyle = 'rgba(255, 255, 255, 0.82)';
    ctx.fillRect(0, h-72, w, 72);
    ctx.fillStyle = '#8a5bd9';
    ctx.font = 'bold 28px Nunito, Arial';
    ctx.fillText('what you feel right now?', 20, h-26);
    const dataUrl = canvas.toDataURL('image/png');
    setPhoto(dataUrl);
    stopStream();
  };

  const retake = () => {
    setPhoto(null); setError(null);
    startCamera();
  };

  return (
    <div className="cam-overlay">
      <div className="cam-modal">
        <button className="cam-close" onClick={onClose} aria-label="close">✕</button>
        <div className="cam-title">What you feel right now? 📷</div>
        {!photo ? (
          <div className="cam-content">
            {error && <div className="cam-error">{error}</div>}
            {loading && <div className="cam-hint">Mengaktifkan kamera...</div>}
            {!loading && !error && <video ref={videoRef} className="cam-video mirror-video" playsInline muted autoPlay />}
            <div className="cam-actions">
              <button className="puzzle-btn" onClick={takePhoto} disabled={!!error || loading}>Take Photo</button>
            </div>
          </div>
        ) : (
          <div className="cam-content">
            <img src={photo} alt="preview" className="cam-preview mirror-video" />
            <div className="cam-actions">
              <button className="puzzle-btn ghost" onClick={retake}>Retake</button>
              <button className="puzzle-btn" disabled={sending} onClick={() => onSend(photo)}>{sending ? 'Sending...' : 'Send'}</button>
            </div>
          </div>
        )}
        <canvas ref={canvasRef} style={{display:'none'}} />
      </div>
    </div>
  );
} */
